import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';
import { ShellComponent } from './feature/shell/shell.component';
import { ErrorComponent } from './feature/error/error.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { ChartsModule } from 'ng2-charts';
import { UserIdleModule } from 'angular-user-idle';
//import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Select2Module } from 'ng-select2-component';
import { MatSelectModule } from "@angular/material/select";
import { MatCardModule } from "@angular/material/card";
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import { AmountFormatPipe } from './amount-format.pipe';

@NgModule({
  declarations: [AppComponent, ShellComponent, ErrorComponent, AmountFormatPipe],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    Select2Module,
    MatSelectModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    //NgbModule,
    NgSelectModule,
    ChartsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    // Optionally you can set time for `idle`, `timeout` and `ping` in seconds.
    UserIdleModule.forRoot({ idle: 900, timeout: 3, ping: 25 }),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgbModule,
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule { }

